const links = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "Portfolio",
      link: "/portfolio",
    },
    {
      name: "Contact me",
      link: "/contact-me",
    },
  ];

export default links;